import { render, staticRenderFns } from "./BlogComment.vue?vue&type=template&id=1e62edd6&scoped=true&"
import script from "./BlogComment.vue?vue&type=script&lang=js&"
export * from "./BlogComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e62edd6",
  null
  
)

export default component.exports